import { render, staticRenderFns } from "./addPaymentGatewayType.vue?vue&type=template&id=137fcd66&lang=true"
import script from "./addPaymentGatewayType.vue?vue&type=script&lang=js"
export * from "./addPaymentGatewayType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports